import React, { useEffect, useState } from "react";

const AdminSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const API_URL = 'https://snapper.hxbindia.com';
  useEffect(() => {
    fetch(`${API_URL}/admin/submissions`)
      .then((res) => res.json())
      .then((data) => setSubmissions(data))
      .catch((err) => console.error("Error fetching submissions:", err));
  }, []);

  return (
    <div className="container">
      <h1 className="title">My Enquiry</h1>
      <hr />
      <div className="card">
        <div className="card-content">
          <table className="table ">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Company</th>
                <th>Product</th>
                <th>Subject</th>
                <th>Message</th>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((sub, idx) => (
                <tr key={idx}>
                  <td>{sub.name || '-'}</td>
                  <td>{sub.email || '-'}</td>
                  <td>{sub.phonenumber || '-'}</td>
                  <td>{sub.companyname || '-'}</td>
                  <td>{sub.product || '-'}</td>
                  <td>{sub.subject || '-'}</td>
                  <td className="message-cell">{sub.message || '-'}</td>
                  <td>
                    <span
                      className={`badge ${sub.type === "email" ? "email-badge" : "whatsapp-badge"}`}
                    >
                      {sub.type}
                    </span>
                  </td>
                  <td>{new Date(sub.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminSubmissions;
